import _objectSpread from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { initUserState } from '@vip-activity/business';
import { mapActions } from 'vuex';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import env from '@tencent/vft-common/env';
import vCountDown from '@/mixin/v-countdown';
export default {
  data: function data() {
    return {};
  },
  mixins: [vCountDown],
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isLogin;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return initUserState();

            case 2:
              isLogin = _context.sent;

              if (isLogin) {
                _this.checkLaiseeStatus();
              }

              _this.eventBus.$on('shareTodayLaisee', _this.getRedPacket);

              window.bodymovin.loadAnimation({
                path: 'https://m.film.qq.com/vip-activity/kid-cny2021/lottie/btn/data.json',
                loop: true,
                autoplay: true,
                renderer: 'svg',
                // 渲染方式，有"html"、"canvas"和"svg"三种
                container: _this.$refs.cloud
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    fetcherListLength: function fetcherListLength() {
      return this.fetcherList && this.fetcherList.length;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['getTodayLaisee', 'createTodayLaisee', 'getHistoryRecord'])), {}, {
    showHistory: function showHistory() {
      if (!this.isLogin) {
        this.$openLogin();
        return;
      }

      this.eventBus.$emit('showHistory', true);
    },
    getTime: function getTime() {
      return new Date().setHours(0, 0, 0, 0) + 86400000 - this.now;
    },

    /**
     * 检查今日红包的相关状态
     */
    checkLaiseeStatus: function checkLaiseeStatus() {
      this.checkToday();
      this.checkHistory();
    },

    /**
     * 检查今日领取信息
     */
    checkToday: function checkToday() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getTodayLaisee();

              case 2:
                if (!_this2.todayLaisee) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 5;
                return _this2.updateFetcherList();

              case 5:
                _context2.next = 8;
                break;

              case 7:
                window.localStorage.setItem("".concat(_this2.vuid, "_lastFetcherNum"), 0);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * 检查历史领取信息
     */
    checkHistory: function checkHistory() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getHistoryRecord();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * 前几天是否有新的福袋
     */
    // checkLastDate() {
    //   const record = this.historyRecord[0];
    //   if (record.list.length < 3) {
    //     console.log('之前没领完');
    //   }
    // },

    /**
     * 点击分享按钮
     */
    getRedPacket: function getRedPacket() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(!env.isKidApp && !_this4.test)) {
                  _context4.next = 3;
                  break;
                }

                _this4.openPageWithAccount({
                  ptag: 'xqehbzw'
                });

                return _context4.abrupt("return");

              case 3:
                _context4.next = 5;
                return initUserState();

              case 5:
                if (_this4.loginService.isLogin) {
                  _context4.next = 8;
                  break;
                }

                _this4.loginService.openLogin();

                return _context4.abrupt("return");

              case 8:
                _this4.shareRedPacket();

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }),
  components: {
    Avatar: Avatar
  }
};